import React from 'react';

function ChevronRightIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15.3,9c0.6,0.6,0.6,1.5,0,2l-8.6,8.6c-0.6,0.6-1.5,0.6-2,0c-0.6-0.6-0.6-1.5,0-2l7.6-7.6L4.7,2.4c-0.6-0.6-0.6-1.5,0-2s1.5-0.6,2,0L15.3,9L15.3,9z"/>
    </svg>
  );
}

export default ChevronRightIcon;
